import { Component, Injector, OnInit }                      from '@angular/core';
import { Router, ActivatedRoute }                           from '@angular/router';
import { TranslateService }                                 from '@ngx-translate/core';
import { CookieService }                                    from 'ngx-cookie-service';
import { UtilityService }                                   from './../_service/utility.service';
import { LocalStorageService } 				    from './../_service/local-storage.service';
import { SessionStorageService }                            from './../_service/session-storage.service';
import { InterfaceService }                                 from './../_service/interface.service';
import { UserService }                                      from './../_service/user.service';
import { ResizeService }                                    from '../_service/resize-service';
import { EventEmitterService }                              from '../_service/event-emitter.service';
import { TimeoutError }                                     from 'rxjs';

// import * as angular_constants 				    from "../../../angular.json";
import { Constants }                            from '../models/Constants';

import { GroupService } from '../_service/group.service';
import ObjectList from '../models/ObjectList';

@Component({
    selector: 'BaseComponent',
    templateUrl: 'BaseComponent.html',
})
export class BaseComponent implements OnInit {
    settings: Object;
    text_color = "#FFFFFF";
    project_labels = "";
    default_datef: string = 'yyyy-MM-dd HH:mm:ss';
    label_datef: string = 'yyyy-MM-dd HH:mm:ss';
    errors = false;
    error_message = '';
    error_detailed_message = '';
    error_trace = '';
    
    protected months                    : ObjectList<Object> = new ObjectList();
    protected current_month             : number = 0;
    protected current_week              : number = 0;

    protected _router                   : Router;
    protected _userService              : UserService;
    protected _groupService             : GroupService;
    protected _interfaceService         : InterfaceService;
    protected _route                    : ActivatedRoute;
    protected _utilityService           : UtilityService;
    protected _translateService         : TranslateService;
    protected _sessionStorageService    : SessionStorageService;
    protected _resizeService            : ResizeService;
    protected _eventEmitterService      : EventEmitterService;
    protected _cookieService            : CookieService;
    protected _localStorageService: LocalStorageService;

    constructor(injector: Injector) 
    {
        this._resizeService         = injector.get(ResizeService);
        this._router                = injector.get(Router);
        this._userService           = injector.get(UserService);
        this._groupService          = injector.get(GroupService);
        this._interfaceService      = injector.get(InterfaceService);
        this._route                 = injector.get(ActivatedRoute);
        this._utilityService        = injector.get(UtilityService);
        this._translateService      = injector.get(TranslateService);
        this._sessionStorageService = injector.get(SessionStorageService);
        this._localStorageService   = injector.get(LocalStorageService);
        this._eventEmitterService   = injector.get(EventEmitterService);
        this._cookieService 	    = injector.get(CookieService);

        // var all_keys = Object.keys(angular_constants.projects);
        // this.project_labels         = all_keys[0];
        this.project_labels         = Constants.PROJECT_LABEL;
        this.current_month          = UtilityService.getCurrentMonth();
        this.current_week           = UtilityService.getWeekNumber();
        
        this.months.push({ "id" : 1 , "name"  : "jan" } , "id");
        this.months.push({ "id" : 2 , "name"  : "feb" } , "id");
        this.months.push({ "id" : 3 , "name"  : "mar" } , "id");
        this.months.push({ "id" : 4 , "name"  : "apr" } , "id");
        this.months.push({ "id" : 5 , "name"  : "may" } , "id");
        this.months.push({ "id" : 6 , "name"  : "jun" } , "id");
        this.months.push({ "id" : 7 , "name"  : "jul" } , "id");
        this.months.push({ "id" : 8 , "name"  : "ago" } , "id");
        this.months.push({ "id" : 9 , "name"  : "set" } , "id");
        this.months.push({ "id" : 10 , "name" : "oct" } , "id");
        this.months.push({ "id" : 11 , "name" : "nov" } , "id");
        this.months.push({ "id" : 12 , "name" : "dec" } , "id");
    }

    ngOnInit() 
    {
        
    }
    
    getSoftwareColor()
    {
        return this.getSettingValue("software_color");
    }

    getTextColor()
    {
        var hexcolor = this.getSettingValue("software_color");
        if (hexcolor !== undefined)
        {
            hexcolor = hexcolor.replace("#", "");
            var r = parseInt(hexcolor.substr(0, 2), 16);
            var g = parseInt(hexcolor.substr(2, 2), 16);
            var b = parseInt(hexcolor.substr(4, 2), 16);
            var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
            return (yiq >= 128) ? 'black' : 'white';
        }
        return this.text_color;
    }

    getBackgroundColorStyle()
    {
        return { 'background-color' : this.getSoftwareColor() }
    }

    getTextColorStyle()
    {
        return { 'color'            : this.getTextColor() }
    }

    getSettingValue(label) 
    {
        return Constants.getSettingValue(label);
        // this.settings = localStorage.getItem(this.project_labels + "_software_settings") !== null ? JSON.parse(localStorage.getItem(this.project_labels + "_software_settings")) : null;
        // if (this.settings !== null && this.settings[label] !== null) {
        //     return this.settings[label]
        // }
        // else {
        //     return undefined;
        // }        
    }

    getUrlSetting(label)
    {
        //var tmp                 = localStorage.getItem(this.project_labels + "_server_urls");
        var server_urls         = Constants.SERVER_URLS;
        return server_urls[label];
    }

    getHeaderColor()
    {
        var color = this.getSettingValue("software_color");
        if (color !== null)
        {
        return { 
                    'background-color' : color ,
                    'color'            : this.hexToLuma(color)
               }
        }
        return {}
    }

    hexToLuma (colour) {
        const hex   = colour.replace(/#/, '');
        const r     = parseInt(hex.substr(0, 2), 16);
        const g     = parseInt(hex.substr(2, 2), 16);
        const b     = parseInt(hex.substr(4, 2), 16);

        var o = Math.round(((parseInt(r.toString(),10) * 299) +
                        (parseInt(g.toString(),10) * 587) +
                        (parseInt(b.toString(),10) * 114)) / 1000);
        var fore = (o > 125) ? 'black' : 'white';
        return fore;
    };

    handleErrorFromResponse(error) {
        this.errors = true;
        // console.log(error);
        if (error instanceof TimeoutError) {
            // Timeout Error raised
            this.error_message = error.name;
            this.error_detailed_message = error.message;
        }
        else {
            // Error in our JSON format
            if (error['message']) {
                this.error_message = error['message'];
            }
            if (error['detailedMessage']) {
                this.error_detailed_message = error['detailedMessage'];
            }
            if (error['trace']) {
                this.error_trace = error['trace'];
            }
        }
    }

    compareModels(t1: any, t2: any): boolean {
        return t1 && t2 ? t1.id === t2.id : t1 === t2;
    }
    
    compareModelsCode(t1: any, t2: any): boolean {
        return t1 && t2 ? t1.code === t2.code : t1 === t2;
    }
        
    
    hasPerm(code , permission)
    {
        var user_info    = JSON.parse(localStorage.getItem(this.project_labels + "_user_info"));
        //Implement something here and return true or false
        return false;
    }

    getUtil() {
        return UtilityService;
    }

    
}
